import { render, staticRenderFns } from "./ApplicantDashboard.vue?vue&type=template&id=04a0d893&scoped=true"
import script from "./ApplicantDashboard.vue?vue&type=script&lang=js"
export * from "./ApplicantDashboard.vue?vue&type=script&lang=js"
import style0 from "./ApplicantDashboard.vue?vue&type=style&index=0&id=04a0d893&prod&scoped=true&lang=css"
import style1 from "./ApplicantDashboard.vue?vue&type=style&index=1&id=04a0d893&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a0d893",
  null
  
)

export default component.exports